import { useEffect, useState } from 'react';
import { ExtraTableResize } from '../../extraTableResize';
import TableComponent from '../../TableComponent';
import moment from 'moment';

interface IProps {
  dataNonyusaki: any[];
  rowIndex: number;
  changeRowIndex: (rowIndex: number) => void; // 行を選択する
}

const NonyusakiSearchTable: React.FC<IProps> = (props: IProps) => {
  const columnInit: any = [
    {
      title: '納入先名',
      dataIndex: 'nouNm',
      width: 600,
      ellipsis: true,
    },
    {
      title: '住所',
      dataIndex: 'adr',
      width: 830,
      ellipsis: true,
    },
    {
      title: '電話番号',
      dataIndex: 'telNo',
      width: 150,
      ellipsis: true,
      className: 'clsTelNo',
    },
    {
      title: 'FAX番号',
      dataIndex: 'faxNo',
      width: 150,
      ellipsis: true,
      className: 'clsFaxNo',
    },
    {
      title: '現場担当者',
      dataIndex: 'tanNm',
      width: 200,
      ellipsis: true,
    },
    {
      title: '現場担当者TEL',
      dataIndex: 'tantelNo',
      width: 150,
      ellipsis: true,
      className: 'clsTantelNo',
    },
    {
      title: '携帯mail-add',
      dataIndex: 'cellmailAdr',
      width: 500,
      ellipsis: true,
    },
    {
      title: 'mail-add',
      dataIndex: 'mailAdr',
      width: 500,
      ellipsis: true,
    },
    {
      title: '郵便番号',
      dataIndex: 'yubinNo',
      width: 150,
      ellipsis: true,
    },
    {
      title: '工事管理番号',
      dataIndex: 'koukanNo',
      width: 150,
      ellipsis: true,
    },
    {
      title: '納入先メモ',
      dataIndex: 'nouMemo',
      width: 320,
      ellipsis: true,
    },
    {
      title: '送り状メモ',
      dataIndex: 'okuMemo',
      width: 320,
      ellipsis: true,
    },

    {
      title: '気付',
      dataIndex: 'kizMemo',
      width: 320,
      ellipsis: true,
    },
    {
      title: '車両条件',
      dataIndex: 'syaMemo',
      width: 320,
      ellipsis: true,
    },
    {
      title: '登録日',
      dataIndex: 'insDt',
      width: 100,
      ellipsis: true,
      className: 'clsInsDt',
      render: (_: any, record: any) => {
        if (Boolean(record.insDt) !== false)
          return <div>{moment(record['insDt']).format('YYYY/MM/DD')}</div>;
      },
    },
    {
      title: 'SEQ',
      dataIndex: 'nouCd',
      width: 100,
      ellipsis: true,
      className: 'clsNouCd',
    },
    {
      title: '最終発注日',
      dataIndex: 'endhatDt',
      width: 100,
      ellipsis: true,
      className: 'clsEndhatDt',
      render: (_: any, record: any) => {
        if (Boolean(record.endhatDt) !== false)
          return <div>{moment(record['endhatDt']).format('YYYY/MM/DD')}</div>;
      },
    },
  ];

  const [columns, changeColumns] = useState(columnInit);
  const [rIdx, changeRowIndex] = useState(-1);

  useEffect(() => {
    if (rIdx >= 0) {
      props.changeRowIndex(rIdx);
      changeRowIndex(-1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rIdx]);

  return (
    <>
      <ExtraTableResize>
        <TableComponent
          columns={columns}
          data={props.dataNonyusaki}
          minHeight="35vh"
          maxHeight="35vh"
          updateColumns={changeColumns}
          rowIndex={rIdx}
          changeRowIndex={changeRowIndex}
        />
      </ExtraTableResize>
    </>
  );
};
export default NonyusakiSearchTable;
